let displayRef = function() {
    this.$refs.addGalley.click();
};
export default displayRef;
